<template>
    <div>
        <el-button type="primary" @click="addmoudule" style="margin-top:2%;margin-left:3%">新增模板</el-button>
        <el-button type="primary" @click="addmoudule2" style="margin-top:2%;margin-left:3%">新增模板（横版）</el-button>
        <el-table :data="tableData" style="width: 80vw; margin-top: 3%;margin-left: 3%;" border>
            <el-table-column type="index" label="No." align="center" :index="indexAdd">
            </el-table-column>
            <el-table-column prop="name" label="模板名称" align="center">
            </el-table-column>
            <el-table-column prop="enTitle" label="英文标题" align="center">
            </el-table-column>
            <el-table-column prop="cnTitle" label="中文标题" align="center">
            </el-table-column>
            <el-table-column prop="content" label="内容" align="center" :show-overflow-tooltip=true>
            </el-table-column>
            <el-table-column prop="issueDate" label="签发日期" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">预览模板</el-button>
                    <el-button size="mini" type="primary" @click="handleDelete(scope.row)"
                        slot="reference">删除模板</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="margin-left:30%;margin-top: 10px;" background layout="total, prev, pager, next, jumper"
            :total="total" @current-change="currentchange" :page-size.sync="limit">
        </el-pagination>
        <el-dialog title="新增模板" :visible.sync="dialogVisibleadd" width="70%" @close="dialogVisibleaddcancle('ruleForm')"
            :close-on-click-modal=false>
            <div>
                <el-row>
                    <el-col :span="10" style="margin-left:5%;margin-top: 12%;">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" :rules="rules"
                            ref="formInline">
                            <el-form-item label="选择底图" style="display:block;">
                                <el-select v-model="bgvalue" placeholder="选择底图"
                                    style="width:400px;margin-bottom: 40px;">
                                    <el-option v-for="item in bgoptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="模板名称" style="display:block;">
                                <el-input v-model="formInline.modules" placeholder=""
                                    style="width:400px;margin-bottom: 40px;"></el-input>
                            </el-form-item>
                            <el-form-item label="英文标题" style="display:block;" v-if="bgvalue !== 'https://statools.posedu.com.cn/model/needimg.jpg'">
                                <el-input v-model="formInline.Englishtag" placeholder=""
                                    style="width:400px;margin-bottom: 40px;"></el-input>
                            </el-form-item>
                            <el-form-item label="中文标题" style="display:block;" v-if="bgvalue !== 'https://statools.posedu.com.cn/model/needimg.jpg'">
                                <el-input v-model="formInline.chinesetag" placeholder=""
                                    style="width:400px;margin-bottom: 40px;"></el-input>
                            </el-form-item>
                            <el-form-item label="内容" style="display:block;margin-left: 28px;">
                                <el-input v-model="formInline.content" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item label="签发日期" style="display:block;">
                                <el-input v-model="formInline.time" placeholder=""
                                    style="width:400px;margin-bottom: 40px;"></el-input>
                            </el-form-item>
                            <el-form-item v-if="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg'" style="display:block;margin-left:28px;">
                                <el-button type="primary" @click="showZhang = !showZhang">{{ showZhang ? '隐藏盖章' : '显示盖章' }}</el-button>
                            </el-form-item>
                            <el-form-item label="大学名称" style="display:block;" v-if="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg'">
                                <el-input v-model="formInline.schoolName" placeholder=""
                                    style="width:400px;margin-bottom: 40px;"></el-input>
                            </el-form-item>
                            <el-form-item label="学校签发日期" style="display:block;" v-if="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg'">
                                <el-input v-model="formInline.schoolTime" placeholder=""
                                    style="width:400px;margin-bottom: 40px;"></el-input>
                            </el-form-item>
                            <el-form-item label="学校logo" style="display:block;" v-if="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg'">
                                <div class="logo-uploader-wrapper">
                                    <el-upload
                                        class="logo-uploader"
                                        :action="upyunAction"
                                        :show-file-list="false"
                                        :http-request="handleLogoUpload"
                                        accept="image/*">
                                        <img v-if="formInline.imgUrl" :src="formInline.imgUrl" class="logo-image">
                                        <i v-else class="el-icon-plus logo-uploader-icon"></i>
                                    </el-upload>
                                    <el-button
                                        v-if="formInline.imgUrl"
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        size="mini"
                                        class="remove-logo-btn"
                                        @click.stop="handleRemoveLogo">
                                    </el-button>
                                </div>
                                <div class="logo-tip" v-if="formInline.imgUrl">点击+可更换，点击删除按钮可移除</div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="8" style="margin-top: 4%;">
                        <div class="box">

                            <div class="box1">
                                <img :src="bgvalue" alt="请选择底图" width="620px" height="877px" />
                                <h3 style="text-align:center;font-color:red" class="box11" id="h31" v-if="bgvalue !== 'https://statools.posedu.com.cn/model/needimg.jpg'">{{
                                    formInline.Englishtag
                                    }}</h3>
                                <h2 style="text-align:center" class="box12" id="h32" v-if="bgvalue !== 'https://statools.posedu.com.cn/model/needimg.jpg'">{{ formInline.chinesetag }}</h2>
                                <h4 style="text-align:left" class="box13" id="h33">{{ formInline.content }}</h4>
                              <p style="text-align:left"
                                 :class="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg' ? 'box14-type9' : 'box14'"
                                 :style="bgvalue === 'https://statools.posedu.com.cn/model/weilai_noper.jpg' && bgvalue !== 'https://statools.posedu.com.cn/model/needimg.jpg' ? { 'margin-top': '-25px' } : {}"
                                 id="h34">{{ formInline.time }}</p>
                              <img v-if="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg' && formInline.imgUrl" :src="formInline.imgUrl" class="school-logo-preview" />
                              <div v-if="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg'" class="type9-right-bottom">
                                <p class="type9-university" id="h35">{{ formInline.schoolName }}</p>
                                <p class="type9-school-date" id="h36">{{ formInline.schoolTime }}</p>
                              </div>
                              <div v-if="bgvalue === 'https://statools.posedu.com.cn/model/needimg.jpg'" class="type9-zhang">
                                <p class="type9_text">位来生涯研究院</p>
                                <img src="https://statools.posedu.com.cn/model/zhang.png" alt="盖章" style="width: 100%;height: 100%;" v-show="showZhang"/>
                              </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleadd = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleaddok('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="新增模板（横版）" :visible.sync="dialogVisibleadd2" width="70%"
            @close="dialogVisibleaddcancle('ruleForm')" :close-on-click-modal=false>
            <div>
                <el-row>
                    <el-col :span="10" style="margin-left:5%;margin-top: 12%;">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" :rules="rules"
                            ref="formInline">
                            <el-form-item label="选择底图" style="display:block;">
                                <el-input value="横版证书" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="模板名称" style="display:block;">
                                <el-input v-model="hbname"></el-input>
                            </el-form-item>
                            <el-form-item label="内容" style="display:block;margin-left: 28px;">
                                <el-input v-model="newText" placeholder="" style="width:400px;margin-bottom: 40px;"
                                    type="textarea"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="8" style="margin-top: 4%;">
                        <div
                            style="position: relative; width: 701.6px; height: 496px;font-size:14px;line-height: 30px;font-family: simsun;">
                            <img style="position: absolute;" src="https://statools.posedu.com.cn/model/Horizontal.png"
                                alt="请选择底图" width="701.6px" height="496px" />

                            <div style="width: 70%;position: absolute;top: 190px;left: 15%;font-size: 14px;">
                                {{ 'XXXXXX' }} 同志:
                            </div>
                            <div
                                style="width: 70%;position: absolute;top: 225px;left: 15%;text-indent: 2em;font-size: 13px;">
                                <div>
                                    {{ newText }}
                                </div>
                                <div style="margin-top: 10px;font-size: 13px;">
                                    证书编号：{{ "WEILAIJIAOYUXXX" }}
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleadd2 = false, newText = '', hbname = ''">取 消</el-button>
                <el-button type="primary" @click="add2">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog title="预览模板" :visible.sync="previewdialogVisible" width="70%"
            @close="previewdialogVisiblecancle('ruleForm')" :close-on-click-modal=false>
            <div>
                <el-row>
                    <el-col :span="10" style="margin-left:5%;margin-top: 12%;">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" :rules="rules"
                            ref="formInline">
                            <el-form-item label="模板名称" style="display:block;">
                                <el-input v-model="formInline.modules" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="英文标题" style="display:block;" v-if="formInline.type != 9">
                                <el-input v-model="formInline.Englishtag" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="中文标题" style="display:block;" v-if="formInline.type != 9">
                                <el-input v-model="formInline.chinesetag" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="内容" style="display:block;margin-left: 28px;">
                                <el-input v-model="formInline.content" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" type="textarea" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="签发日期" style="display:block;">
                                <el-input v-model="formInline.time" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" disabled></el-input>
                            </el-form-item>
                            <el-form-item v-if="formInline.type == 9" style="display:block;margin-left:28px;">
                                <el-button type="primary" @click="showZhang = !showZhang">{{ showZhang ? '隐藏盖章' : '显示盖章' }}</el-button>
                            </el-form-item>
                            <el-form-item label="大学名称" style="display:block;" v-if="formInline.type == 9">
                                <el-input v-model="formInline.schoolName" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="学校签发日期" style="display:block;" v-if="formInline.type == 9">
                                <el-input v-model="formInline.schoolTime" placeholder=""
                                    style="width:400px;margin-bottom: 40px;" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="学校logo" style="display:block;" v-if="formInline.type == 9">
                                <div class="logo-uploader-wrapper">
                                    <el-upload
                                        class="logo-uploader"
                                        :action="upyunAction"
                                        :show-file-list="false"
                                        :http-request="handleLogoUpload"
                                        accept="image/*">
                                        <img v-if="formInline.imgUrl" :src="formInline.imgUrl" class="logo-image">
                                        <i v-else class="el-icon-plus logo-uploader-icon"></i>
                                    </el-upload>
                                    <el-button
                                        v-if="formInline.imgUrl"
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        size="mini"
                                        class="remove-logo-btn"
                                        @click.stop="handleRemoveLogo">
                                    </el-button>
                                </div>
                                <div class="logo-tip" v-if="formInline.imgUrl">点击+可更换，点击删除按钮可移除</div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="8" style="margin-top: 4%;">
                        <div class="box">

                            <div class="box1">
                                <img :src="formInline.img" alt="底图加载失败" width="620px" height="877px" />
                                <p style="text-align:center" class="box11" id="h31" v-if="formInline.type != 9">{{ formInline.Englishtag }}</p>
                                <p style="text-align:center" class="box12" id="h32" v-if="formInline.type != 9">{{ formInline.chinesetag }}</p>
                                <p style="text-align:left" class="box13" id="h33">{{ formInline.content }}</p>
                                <p style="text-align:left"
                                   :class="formInline.type == 9 ? 'box14-type9' : 'box14'"
                                   :style="formInline.type == 8 && formInline.type != 9 ? { 'margin-top': '-25px' } : {}"
                                   id="h34">{{ formInline.time }}</p>
                                <img v-if="formInline.type == 9 && formInline.imgUrl" :src="formInline.imgUrl" class="school-logo-preview" />
                                <div v-if="formInline.type == 9" class="type9-right-bottom">
                                    <p class="type9-university" id="h35">{{ formInline.schoolName }}</p>
                                    <p class="type9-school-date" id="h36">{{ formInline.schoolTime }}</p>
                                </div>
                                <div v-if="formInline.type == 9" class="type9-zhang">
                                  <p class="type9_text">位来生涯研究院</p>
                                  <img src="https://statools.posedu.com.cn/model/zhang.png" alt="底图加载失败" style="width: 100%;height: 100%;" v-show="showZhang"/>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="previewdialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="previewdialogVisibleok('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="预览模板" :visible.sync="previewdialogVisible2" width="70%"
            @close="dialogVisibleaddcancle('ruleForm')" :close-on-click-modal=false>
            <div>
                <el-row>
                    <el-col :span="10" style="margin-left:5%;margin-top: 12%;">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" :rules="rules"
                            ref="formInline">
                            <el-form-item label="选择底图" style="display:block;">
                                <el-input value="横版证书" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="内容" style="display:block;margin-left: 28px;">
                                <el-input v-model="newText" placeholder="" style="width:400px;margin-bottom: 40px;"
                                    type="textarea" disabled></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="8" style="margin-top: 4%;">
                        <div
                            style="position: relative; width:701.6px; height: 496px;line-height: 30px;font-family: simsun;">
                            <img style="position: absolute;" src="https://statools.posedu.com.cn/model/Horizontal.png"
                                alt="请选择底图" width="701.6px" height="496px" />

                            <div style="width: 70%;position: absolute;top: 190px;left: 15%;font-size: 14px;">
                                {{ 'XXXXXX' }} 同志:
                            </div>
                            <div
                                style="width: 70%;position: absolute;top: 225px;left: 15%;text-indent: 2em;font-size: 13px;">
                                <div>
                                    {{ newText }}
                                </div>
                                <div style="margin-top: 10px;font-size: 13px;">
                                    证书编号：{{ "WEILAIJIAOYUXXX" }}
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="okReview">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import api from '../router/api'
import { uploadCloud } from '../utils/upyun'
export default {
    data() {
        return {
            newText: "",
            previewdialogVisible2: false,
            hbname: "",
            page: 1,
            total: 0,
            limit: 10,
            tableData: [],
            formInline: {
                modules: '',
                Englishtag: '',
                chinesetag: '',
                content: '',
                time: '',
                img: '',
                type: '',
                imgUrl: '',
                schoolName: '',
                schoolTime: ''
            },
            showZhang: false,
            bgoptions: [{
                value: 'https://statools.posedu.com.cn/model/weilai.png',
                label: '位来教育'
            }, {
              value: 'https://statools.posedu.com.cn/model/weilai_noper.jpg',
              label: '位来教育无签名'
            }, {
                value: 'https://statools.posedu.com.cn/model/yize.jpg',
                label: '伊泽教育'
            }, {
              value: 'https://statools.posedu.com.cn/model/yundai.jpg',
              label: '云代教育'
            }, {
              value: 'https://statools.posedu.com.cn/model/needimg.jpg',
              label: '位来-带学校logo'
            }
            ],
            bgvalue: 'https://statools.posedu.com.cn/model/weilai.png',
            upyunAction: 'https://v0.api.upyun.com/cert-images',
            type: {
                'https://statools.posedu.com.cn/model/weilai.png': 3,
                'https://statools.posedu.com.cn/model/yize.jpg': 5,
                'https://statools.posedu.com.cn/model/yundai.jpg': 4,
                'https://statools.posedu.com.cn/model/weilai_noper.jpg': 8,
                'https://statools.posedu.com.cn/model/needimg.jpg': 9
            },
            //校验
            rules: {
                // tag: [{ required: true, message: "请输入标签1", trigger: "blur" },
                // { max: 20, message: "最多不可超过20个字", trigger: "blur" }],
            },
            //titley 内容据上面的高度  titlex内容据页面宽度
            titley: 0,
            titlex: 0,
            ctitley: 0,
            ctitlex: 0,
            contenty: 0,
            contentx: 0,
            timey: 0,
            timex: 0,
            schoolNamey: 0,
            schoolNamex: 0,
            schoolTimey: 0,
            schoolTimex: 0,
            //控制新增模板弹窗
            dialogVisibleadd: false,
            //预览模板弹窗
            previewdialogVisible: false,
            dialogVisibleadd2: false
        };
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.$post("selectTemplateList", { page: this.page, limit: this.limit }).then((res) => {
                this.tableData = res.data.list
                this.total = res.data.total
            });
        },
        //点击新增模板
        addmoudule() {
            this.formInline.modules = ''
            this.formInline.Englishtag = ''
            this.formInline.chinesetag = ''
            this.formInline.content = ''
            this.formInline.time = ''
            this.formInline.img = ''
            this.formInline.imgUrl = ''
            this.formInline.schoolName = ''
            this.formInline.schoolTime = ''
            this.bgvalue = 'https://statools.posedu.com.cn/model/weilai.png'
            this.dialogVisibleadd = true
        },

        addmoudule2() {
            this.formInline.modules = ''
            this.formInline.Englishtag = ''
            this.formInline.chinesetag = ''
            this.formInline.content = ''
            this.formInline.time = ''
            this.formInline.img = ''
            this.dialogVisibleadd2 = true
        },
        //获取坐标
        getcoordinate() {

            //内容x坐标
            let x1 = document.querySelector('#h31')
            let x2 = document.querySelector('#h32')
            let x3 = document.querySelector('#h33')
            let x4 = document.querySelector('#h34')
            let x5 = document.querySelector('#h35')
            let x6 = document.querySelector('#h36')
            let box = document.querySelector('.box')
            if (x1 && box) {
                this.titley = Math.floor(x1.getBoundingClientRect().y - box.getBoundingClientRect().y)
                this.titlex = Math.floor(x1.getBoundingClientRect().x - box.getBoundingClientRect().x)
            }
            if (x2 && box) {
                this.ctitley = Math.floor(x2.getBoundingClientRect().y - box.getBoundingClientRect().y)
                this.ctitlex = Math.floor(x2.getBoundingClientRect().x - box.getBoundingClientRect().x)
            }
            if (x3 && box) {
                this.contenty = Math.floor(x3.getBoundingClientRect().y - box.getBoundingClientRect().y)
                this.contentx = Math.floor(x3.getBoundingClientRect().x - box.getBoundingClientRect().x)
            }
            if (x4 && box) {
                this.timey = Math.floor(x4.getBoundingClientRect().y - box.getBoundingClientRect().y)
                this.timex = Math.floor(x4.getBoundingClientRect().x - box.getBoundingClientRect().x)
            }
            if (x5 && box) {
                this.schoolNamey = Math.floor(x5.getBoundingClientRect().y - box.getBoundingClientRect().y)
                this.schoolNamex = Math.floor(x5.getBoundingClientRect().x - box.getBoundingClientRect().x)
            }
            if (x6 && box) {
                this.schoolTimey = Math.floor(x6.getBoundingClientRect().y - box.getBoundingClientRect().y)
                this.schoolTimex = Math.floor(x6.getBoundingClientRect().x - box.getBoundingClientRect().x)
            }

        },
        //新增模板确定
        dialogVisibleaddok() {
            this.getcoordinate()
            let x1 = this.titlex
            let y1 = this.titley
            let x2 = this.ctitlex
            let y2 = this.ctitley
            let x3 = this.contentx
            let y3 = this.contenty
            let x4 = this.timex
            let y4 = this.timey
            let x5 = this.schoolNamex
            let y5 = this.schoolNamey
            let x6 = this.schoolTimex
            let y6 = this.schoolTimey

            this.$post("addTemplate", {
                name: this.formInline.modules,
                enTitle: this.formInline.Englishtag,
                enOrientation: x1 * 4 + ',' + y1 * 4,
                cnTitle: this.formInline.chinesetag,
                cnOrientation: x2 * 4 + ',' + y2 * 4,
                content: this.formInline.content,
                conOrientation: x3 * 4 + ',' + y3 * 4,
                issueDate: this.formInline.time,
                dateOrientation: x4 * 4 + ',' + y4 * 4,
                type: this.type[this.bgvalue],
                imgUrl: this.formInline.imgUrl,
                schoolName: this.formInline.schoolName,
                schoolNameOrientation: x5 * 4 + ',' + y5 * 4,
                schoolTime: this.formInline.schoolTime,
                schoolTimeOrientation: x6 * 4 + ',' + y6 * 4
            }).then((res) => {
                this.getData()
                this.dialogVisibleadd = false
            });



        },
        //新增模板取消
        dialogVisibleaddcancle() {
            this.dialogVisibleadd = false
        },
        //点击预览模板按钮 行
        handleUpdate(row) {
            if (row.type == 6) {
                this.newText = row.content;
                this.previewdialogVisible2 = true;
                return
            }



            this.previewdialogVisible = true
            console.log('aaa', row)
            this.formInline.modules = row.name
            this.formInline.Englishtag = row.enTitle
            this.formInline.chinesetag = row.cnTitle
            this.formInline.content = row.content
            this.formInline.time = row.issueDate
            this.formInline.type = row.type
            this.formInline.imgUrl = row.imgUrl || ''
            this.formInline.schoolName = row.schoolName || row.universityName || ''
            this.formInline.schoolTime = row.schoolTime || row.schoolIssueDate || ''
          let imgUrl = 'https://statools.posedu.com.cn/model/weilai.png';
          switch (row.type){
            case 4:
              imgUrl = 'https://statools.posedu.com.cn/model/yundai.jpg';
              break;
              case 5:
                imgUrl = 'https://statools.posedu.com.cn/model/yize.jpg';
              break;
            case 8:
              imgUrl = 'https://statools.posedu.com.cn/model/weilai_noper.jpg';
              break;
            case 9:
              imgUrl = 'https://statools.posedu.com.cn/model/needimg.jpg';
              break;
              default:
                imgUrl = 'https://statools.posedu.com.cn/model/weilai.png';
                break;
          }
            this.formInline.img = imgUrl;

        },
        // 点击删除模板按钮 行
        handleDelete(row) {
            let id = row.id
            console.log(id)
            // axios({
            //     method: 'get',
            //     url: api.delTemplate + `${id}`,
            //     headers: {
            //     },
            //     data: '',
            //     cache: false, //设置是否第二次是否从缓存中读取
            //     processData: false,//将数据类型序列换成application/x-www-form-urlencoded ，fasle表示关闭
            //     contentType: false//默认值为application/x-www-form-urlencoded，false表示关闭

            // }).then(res => {
            //     this.getData()
            //     //console.log("成功"，success)

            // }).catch(err => {
            //     //console.log("失败", err)
            // });

            this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.$get("delTemplate", id).then((res) => {
                    console.log("res", res);
                    if (res.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getData()
                    } else {

                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });


        },
        //预览模板弹窗取消按钮
        previewdialogVisiblecancle() {
            this.previewdialogVisible = false

        },
        //预览模板弹窗确定按钮
        previewdialogVisibleok() {
            this.previewdialogVisible = false
        },
        currentchange(val) {
            this.page = val
            this.$post("selectTemplateList", { page: val, limit: this.limit }).then((res) => {
                this.tableData = res.data.list
            });
        },
        indexAdd(index) {
            const page = this.page // 当前页码
            const pagesize = 10// 每页条数
            return index + 1 + (page - 1) * pagesize
        },

        add2() {
            this.$post("addTemplate", {
                name: "横版证书",
                content: this.newText,
                name: this.hbname,
                type: "6"
            }).then((res) => {
                this.getData()
                this.dialogVisibleadd2 = false;
                this.newText = "";
                this.hbname = "";
            });
        },
        okReview() {
            this.newText = "";
            this.previewdialogVisible2 = false;
        },
        handleLogoUpload(param) {
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            uploadCloud({
                file: param.file,
                action: this.upyunAction,
                moh: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            let percent = (progressEvent.loaded / progressEvent.total * 100) | 0;
                            loading.text = '上传中... ' + percent + '%';
                        }
                    }
                }
            }).then((res) => {
                loading.close();
                const IMG_DOMAIN = 'https://cert-images.posedu.cn';
                let imgUrl = '';
                let path = '';
                if (res.data) {
                    if (res.data.url) {
                        path = res.data.url;
                    } else if (res.data.imgUrl) {
                        path = res.data.imgUrl;
                    } else if (typeof res.data === 'string') {
                        path = res.data;
                    }
                }
                if (!path && res.headers) {
                    const location = res.headers['x-upyun-location'] || res.headers['location'];
                    if (location) {
                        path = location;
                    }
                }
                if (!path) {
                    const formData = res.config && res.config.data;
                    if (formData && typeof formData === 'string') {
                        const saveKeyMatch = formData.match(/"save-key":"([^"]+)"/);
                        if (saveKeyMatch && saveKeyMatch[1]) {
                            path = saveKeyMatch[1];
                        }
                    }
                }
                if (path) {
                    if (path.startsWith('http://') || path.startsWith('https://')) {
                        imgUrl = path;
                    } else {
                        imgUrl = IMG_DOMAIN + (path.startsWith('/') ? '' : '/') + path;
                    }
                    this.formInline.imgUrl = imgUrl;
                    this.$message.success('上传成功');
                } else {
                    console.error('无法获取上传后的图片URL', res);
                    this.$message.error('上传成功但获取图片地址失败，请重试');
                }
            }).catch((err) => {
                loading.close();
                console.error('上传失败:', err);
                this.$message.error('上传失败，请重试');
            });
        },
        handleRemoveLogo() {
            this.$confirm('确定要删除学校logo吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.formInline.imgUrl = '';
                this.$message.success('删除成功');
            }).catch(() => {});
        }
    },
};

</script>
<style scoped>
@import '../common/font/font.css';

.box {
    position: relative
}

.box .box1 {
    width: 620px;
    height: 877px;
    position: relative;
}

.box11 {
    color: black;
    font-family: PingFang;
    position: absolute;
    left: 50%;
    top: 29%;
    transform: translateX(-50%);
    margin: 0;
    font-size: 19px;
}

.box12 {
    width: 80%;
    font-size: 50px;
    font-weight: 700;
    color: black;
    font-family: simkai;
    position: absolute;
    left: 50%;
    top: 32%;
    transform: translateX(-50%);
    margin: 0;
}

.box13 {
    line-height: 29px;
    letter-spacing: -1px;
    width: 404px;
    text-indent: 2em;
    font-size: 18px;
    color: black;
    font-family: simsun;
    position: absolute;
    left: 50%;
    top: 46%;
    transform: translateX(-50%);
    margin: 0;
}

.box14 {
    font-size: 18px;
    color: rgb(48, 54, 47);
    font-family: simsun;
    position: absolute;
    left: 30%;
    top: 75%;
    margin-top: 4px;
    transform: translateX(-50%);
    margin: 0;
}

.box14-type9 {
    font-size: 13px;
    color: rgb(48, 54, 47);
    font-family: simsun;
    position: absolute;
    left: 34%;
    top: 74%;
    transform: translateX(-50%);
    margin: 0;
    text-align: center;
}

.type9-right-bottom {
  position: absolute;
  right: 21%;
  top: 71%;
  text-align: center;
}
.type9-zhang{
  position: absolute;
  top: 64%;
  width: 23%;
  left: 23%;
  aspect-ratio: 1 / 1;
}

.type9_text{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 13px;
  color: black;
  font-family: simsun;
  z-index: 1;
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: center;
}

.type9-zhang img{
  width: 100%;
  height: 100%;
  z-index: 2;
  position: relative;
}

.type9-university {
    font-size: 15px;
    color: black;
    font-family: simsun;
    margin: 0 0 8px 0;
    line-height: 1.4;
}

.type9-school-date {
    font-size: 15px;
    color: black;
    font-family: simsun;
    margin: 0;
    line-height: 1.4;
}

.logo-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.3s;
}

.logo-uploader >>> .el-upload:hover {
    border-color: #409EFF;
}

.logo-uploader-icon {
    font-size: 28px;
    color: #8c939d;
}

.logo-image {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: contain;
}

.logo-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 8px;
}

.school-logo-preview {
    position: absolute;
    left: 63%;
    top: 20%;
    transform: translateX(-50%);
    max-width: 120px;
    max-height: 80px;
    object-fit: contain;
}

.logo-uploader-wrapper {
    position: relative;
    display: inline-block;
}

.logo-uploader-wrapper .remove-logo-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 10;
}
</style>


// WEBPACK FOOTER //
// src/views/TemplateManagement.vue



// WEBPACK FOOTER //
// src/views/TemplateManagement.vue